// extracted by mini-css-extract-plugin
export var active = "_gs-7";
export var blink = "_gs-8";
export var dropDownSelector = "_gs-4";
export var dropDownWrapper = "_gs-3";
export var fakeCursor = "_gs-6";
export var fontSizeButton = "_gs-9";
export var formQuillEditor = "_gs-0";
export var pressed = "_gs-a";
export var qlBlank = "_gs-1";
export var textFormattingToolbar = "_gs-2";
export var textToolbarOption = "_gs-5";